import React, { useRef } from "react";
import { Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import dashboardArticle2 from "../../assets/images/dashboard-article-2.png";
import dashboardArticle3 from "../../assets/images/dashboard-article-3.png";
import dashboardArticle4 from "../../assets/images/dashboard-article-4.png";
import article2 from "../../assets/images/image2.png";
import PropTypes from 'prop-types'

// Mobile Article Card Component
  const ArticleCard = ({ article }) => (
    <Card style={{ border: "none", backgroundColor: article.color }} className="custom-shadow mb-3">
      <a
        href={article.link}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-5 p-0 d-flex align-items-center">
            <Card.Img
              variant="top"
              src={article.image}
              alt={article.title}
              className="dashboard-article-image"
              style={{
                height: "100%",
                minHeight: "121px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
            </div>
            <div className="col-7 p-0 d-flex align-items-center py-2">
              <Card.Body className="p-0 px-2">
                <div className="text-color-for-mhc">
                  <Card.Title className="mb-0 ageo-medium text-center fs-16"
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                    }}
                  >
                    {article.title}
                  </Card.Title>
                </div>
            </Card.Body>
            </div>
          </div>
        </div>
      </a>
    </Card>
  );

  ArticleCard.propTypes = {
    article: PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string,
      readTime: PropTypes.string,
      link: PropTypes.string,
      color: PropTypes.string,
    }),
  };

const DashboardArticleCarousel = ({isMobile}) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const articles = [
    {
      id: "How-MyHealthChecked-helped-Lynne-Lose-2-1-2-stone",
      image: article2 || "https://via.placeholder.com/400x300",
      title: "“How MyHealthChecked helped Lynne lose 2½ stone”",
      link: "https://myhealthchecked.com/articles/how-myhealthchecked-helped-a-customer-lose-two-and-a-half-stone",
      color: "#F6DBD5",
    },
    {
      id: "I-have-learnt-that-my-body-may-not-benefit-from-food-diets",
      image: dashboardArticle2 || "https://via.placeholder.com/400x300",
      title: "“I have learnt that my body may not benefit from fad diets”",
      link: "https://myhealthchecked.com/articles/i-have-learnt-that-my-body-may-not-benefit-from-fad-diets",
      color: "#CCD8DF",
    },
    {
      id: "The-test-actually-flagged-that-i-am-intolerant-to-lactose-and-gluten-which-explained-why-i-had-been-experiencing-bloating",
      image: dashboardArticle3 || "https://via.placeholder.com/400x300",
      title: "“The test actually flagged that I am intolerant to lactose and gluten, which explained why I had been experiencing bloating”",
      link: "https://myhealthchecked.com/articles/the-test-actually-flagged-that-i-am-intolerant-to-lactose-and-gluten",
      color: "#D1E6E2",
    },
    {
      id: "MyHealthChecked-gave-me-that-extra-support-just-when-I-felt-like-giving-up",
      image: dashboardArticle4 || "https://via.placeholder.com/400x300",
      title: "“MyHealthChecked gave me that extra support just when I felt like giving up”",
      link: "https://myhealthchecked.com/articles/myhealthchecked-gave-me-that-extra-support-just-when-i-felt-like-giving-up",
      color: "#F6DBD5",
    },
  ];

  

  if (isMobile) {
    return (
      <div className="dashboard-article-mobile">
        {articles.map((article) => (
          <ArticleCard key={article.id} article={article} showReadTime={true} color={article.color} />
        ))}
      </div>
    );
  }


  return (
    <div className="testkit-carousel testimonial-carousel">
      <div ref={prevRef} className="custom-prev"></div>
      <div ref={nextRef} className="custom-next"></div>
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        autoplay={{
          delay: 5000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        spaceBetween={30}
        slidesPerView={1}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        pagination={{ clickable: true }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        loop={true}
        breakpoints={{
          640: { slidesPerView: 1, spaceBetween: 15 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 2, spaceBetween: 30 },
          1280: { slidesPerView: 3, spaceBetween: 25 },
        }}
        className="py-3"
      >
        {articles.map((article, index) => (
          <SwiperSlide key={article.id}>
            <a
              href={article.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <Card style={{ border: "none", height: "332px", minWidth: "308px", backgroundColor: article.color, borderRadius: "10px" }} className="custom-shadow">
                <div style={{ }}>
                  <div style={{ position: "relative"}}>
                    <Card.Img
                      variant="top"
                      src={article.image}
                      alt={article.title}
                      className="dashboard-article-image"
                      style={{
                        height: "207px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                  </div>

                  <Card.Body className="text-center">
                    <div className="dashboard-article-title py-2">
                      <Card.Title className="fs-18 ageo-semibold">
                        {article.title}
                      </Card.Title>
                    </div>
                  </Card.Body>
                </div>
              </Card>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

DashboardArticleCarousel.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
isMobile: PropTypes.bool,
};

export default DashboardArticleCarousel;
